import type {Mapper} from 'framework';
import type {BodyMetricWithEntryCount} from '../../domain/body-metric';
import type {BodyMetricListItemDto} from '../dto/body-measurements.dto';
import type {BodyMetricDtoToBodyMetricMapper} from './body-metric-dto-to-body-metric.mapper';

export class BodyMetricListItemDtoToBodyMetricWithEntryCountMapper implements Mapper<
  BodyMetricListItemDto,
  BodyMetricWithEntryCount
> {
  constructor(private readonly metricMapper: BodyMetricDtoToBodyMetricMapper) {}

  transform(dto: BodyMetricListItemDto): BodyMetricWithEntryCount {
    return {
      ...this.metricMapper.transform(dto),
      entryCount: dto.entryCount,
    };
  }
}
